/* Matres wishlist — browser-only (localStorage), port of src/stores/wishlistStore.ts
 * minus the logged-in Supabase sync (per owner: v1 is localStorage only).
 * Stores an array of product snapshots: { id, handle, title, url, image, price, comparePrice }.
 * API: window.MatresWishlist = { list, has, toggle, remove, count }.
 * Emits a 'matres:wishlist' CustomEvent on every change and keeps all
 * [data-wishlist-count] badges and [data-wishlist-toggle] hearts in sync.
 */
(function () {
  var KEY = 'matres_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    sync();
    try { document.dispatchEvent(new CustomEvent('matres:wishlist', { detail: { items: items } })); } catch (e) {}
  }

  function list() { return read(); }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  function toggle(product) {
    var items = read();
    var exists = items.some(function (i) { return i.handle === product.handle; });
    if (exists) {
      items = items.filter(function (i) { return i.handle !== product.handle; });
    } else {
      items.push({
        id: product.id,
        handle: product.handle,
        title: product.title,
        url: product.url,
        image: product.image || '',
        price: product.price,
        comparePrice: product.comparePrice || null
      });
    }
    write(items);
    return !exists;
  }
  function count() { return read().length; }

  function sync() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      var active = h && has(h);
      btn.classList.toggle('is-wishlisted', !!active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  window.MatresWishlist = { list: list, has: has, toggle: toggle, remove: remove, count: count, sync: sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }

  /* Delegated heart clicks: any [data-wishlist-toggle] with data-product JSON */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var product;
    try { product = JSON.parse(btn.getAttribute('data-product')); } catch (err) { return; }
    toggle(product);
    renderPage();
  });

  /* ── Wishlist page renderer (/pages/wishlist) ── */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function money(major) {
    var cur = (window.MATRES && window.MATRES.currency) || 'QAR';
    var n = Number(major);
    return cur + ' ' + (isNaN(n) ? '0.00' : n.toFixed(2));
  }

  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var items = read();
    if (empty) empty.hidden = items.length > 0;
    if (!grid) return;
    grid.style.display = items.length ? 'grid' : 'none';
    grid.innerHTML = items.map(function (i) {
      return '<div class="product-card" style="position:relative;display:flex;flex-direction:column;height:100%;border-radius:16px;overflow:hidden;background:#fff;border:1px solid #EDE4D8;">'
        + '<a href="' + esc(i.url) + '" class="product-card__media" style="overflow:hidden;position:relative;aspect-ratio:1/1;display:block;background:#F9F7F4;">'
        + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy">' : '')
        + '</a>'
        + '<a href="' + esc(i.url) + '" style="text-decoration:none;color:inherit;display:block;flex:1;">'
        + '<div style="padding:12px 12px 0;text-align:center;">'
        + '<h3 style="font-size:13px;margin:0;min-height:20px;display:flex;align-items:center;justify-content:center;"><span class="line-clamp-2" style="font-weight:600;line-height:1.35;color:rgb(83,66,48);">' + esc(String(i.title || '').split('|')[0].trim()) + '</span></h3>'
        + '<div style="margin-top:8px;color:rgb(83,66,48);font-size:14px;font-weight:700;">' + money(i.price) + '</div>'
        + '</div></a>'
        + '<div style="padding:12px;display:flex;gap:8px;">'
        + '<a href="' + esc(i.url) + '" class="product-card__action-btn" style="flex:1;padding:10px 14px;font-size:12px;font-weight:600;text-align:center;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;">' + ((window.MATRES && window.MATRES.strings && window.MATRES.strings.viewProduct) || 'View product') + '</a>'
        + '<button type="button" data-wishlist-remove data-remove-handle="' + esc(i.handle) + '" aria-label="remove" style="width:42px;border:1px solid rgb(238,238,238);border-radius:12px;background:#fff;color:#DA3F3F;cursor:pointer;display:flex;align-items:center;justify-content:center;">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M19 7l-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button>'
        + '</div></div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wishlist-remove]');
    if (!rm) return;
    e.preventDefault();
    remove(rm.getAttribute('data-remove-handle'));
    renderPage();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPage, { once: true });
  } else {
    renderPage();
  }
})();
